import { render, staticRenderFns } from "./DatosLaborales.vue?vue&type=template&id=085b6484&scoped=true"
import script from "./DatosLaborales.vue?vue&type=script&lang=js"
export * from "./DatosLaborales.vue?vue&type=script&lang=js"
import style0 from "./DatosLaborales.vue?vue&type=style&index=0&id=085b6484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085b6484",
  null
  
)

export default component.exports